<template>
    <figure :class="chartContainerClassContent">
        <div class="chart--content" ref="chart"/>
        <figcaption>
            <chart-legend :school-legend="legendItems" :type="type"/>
        </figcaption>
    </figure>
</template>

<script>
    import * as d3 from 'd3';
    import chartMixin from '../chart-mixin.js';
    import { MONOCHROME_WHITE } from '../constants';
    import { mapState } from 'vuex';
    import ChartLegend from '../chart-legend/chart-legend.vue';

    export default {
        components: {
            ChartLegend,
        },
        mixins: [chartMixin],
        props: {
            type: {
                type: String,
                default: '',
            },
            data: {
                type: [String, Array],
                default: () => [],
            },
        },
        data() {
            return {
                legendItems: [],
            };
        },
        computed: {
            ...mapState('viewport', ['width']),
            dimensions() {
                if (this.width > 768) {
                    return { width: 400, height: 400, innerRadius: 90 };
                }
                return { width: 350, height: 350, innerRadius: 80 };
            },
        },
        methods: {
            updateDonutDimensions() {
                const newRadius = Math.min(this.dimensions.width, this.dimensions.height) / 2;

                d3.selectAll('.chart--content-donut svg')
                    .attr('width', this.dimensions.width)
                    .attr('height', this.dimensions.height);

                const arc = d3.arc()
                    .innerRadius(this.dimensions.innerRadius)
                    .outerRadius(newRadius);

                d3.selectAll('.chart--content-donut g')
                    .attr('transform', `translate(${ this.dimensions.width / 2 }, ${ this.dimensions.height / 2 })`);

                d3.selectAll('.chart--content-donut path')
                    .attr('d', arc);
            },
            renderDonutChart() {
                const parentDiv = d3.select(this.$refs.chart);


                const chartContainer = parentDiv.append('div')
                    .attr('class', 'chart--content-donut');
                const chartData = [];
                Object.keys(this.chartData).forEach((key) => {
                    if (key.startsWith('name-')) {
                        const suffix = key.split('-')[1];
                        const dataItem = {
                            name: this.chartData[`name-${ suffix }`],
                            value: this.chartData[`value-${ suffix }`],
                            color: this.chartData[`color-${ suffix }`],
                            displayText: this.chartData[`displayText-${ suffix }`],
                        };
                        chartData.push(dataItem);

                        this.legendItems.push({
                            legendColor: dataItem.color,
                            legendText: dataItem.name,
                        });
                    }
                });

                const radius = Math.min(this.dimensions.width, this.dimensions.height) / 2;

                const svg = chartContainer.append('svg')
                    .attr('width', this.dimensions.width)
                    .attr('height', this.dimensions.height)
                    .append('g')
                    .attr('transform', `translate(${ this.dimensions.width / 2 },${ this.dimensions.height / 2 })`);

                const arc = d3.arc()
                    .innerRadius(radius - 110)
                    .outerRadius(radius);

                const pie = d3.pie()
                    .value(d => d.value)
                    .sort(null);

                svg.selectAll('path')
                    .data(pie(chartData))
                    .enter()
                    .append('path')
                    .attr('d', arc)
                    .attr('fill', d => d.data.color);

                svg.selectAll('text')
                    .data(pie(chartData))
                    .enter()
                    .append('text')
                    .attr('transform', d => `translate(${ arc.centroid(d) })`)
                    .attr('dy', '.35em')
                    .attr('font-size', '12px')
                    .attr('text-anchor', 'middle')
                    .attr('fill', MONOCHROME_WHITE)
                    .text(d => d.data.displayText);
            },
        },
        watch: {
            width() {
                this.updateDonutDimensions();
            },
        },
        mounted() {
            this.renderDonutChart();
        },
    };
</script>
